export function setupAutoLogoutTime(logoutUrl?: string) {
  const remainingTime = getRemainingTime()
  // If client-side, redirect to logout after time has elapsed
  if (typeof window !== 'undefined') {
    setTimeout(function () {
      window.location.href = logoutUrl ?? '/logout'
    }, remainingTime)
  }
}

function getRemainingTime() {
  // Get the current UTC time
  const currentTime = new Date().getTime()

  // Get the UTC time for 8am
  const logoutTime = new Date()
  // It's important that this timing does not extend beyond the backend SESSION max life or the Cognito refresh token life
  logoutTime.setUTCHours(8, 0, 0, 0)

  // Check if 8 am UTC for the current day has already passed.
  if (currentTime > logoutTime.getTime()) {
    // If it has, set logout time for the next day
    logoutTime.setUTCDate(logoutTime.getUTCDate() + 1)
  }

  // Calculate the remaining time until 8am UTC
  return logoutTime.getTime() - currentTime
}
